<template>
	<div class="w-full h-[204px] flex items-center justify-center flex-col border border-gray-200 bg-white rounded">
		<h2 class="font-medium text-2xl text-primary-600">אין הזמנות לאיסוף</h2>
	</div>
</template>

<script>
export default {
	name: "strip-sale-to-be-taken-missing"
}
</script>

<style>

</style>